import React, { useRef } from "react";
import { useFrame } from "@react-three/fiber";

function Stars() {
  const starsRef = useRef();
  const stars = [];

  const starCount = 800;
  const minDistance = 3; 
  const maxDistance = 1500;

  function isTooClose(newStar, existingStars) {
    for (let star of existingStars) {
      const dx = newStar.position[0] - star.position[0];
      const dy = newStar.position[1] - star.position[1];
      const dz = newStar.position[2] - star.position[2];
      const distance = Math.sqrt(dx * dx + dy * dy + dz * dz);
      if (distance < minDistance) return true;
    }
    return false;
  }

  while (stars.length < starCount) {
    const distance = Math.random() * maxDistance;
    const angle1 = Math.random() * Math.PI * 2;
    const angle2 = Math.acos((Math.random() * 2) - 1);

    const newStar = {
      position: [
        distance * Math.sin(angle2) * Math.cos(angle1),
        distance * Math.sin(angle2) * Math.sin(angle1),
        distance * Math.cos(angle2)
      ],
      size: Math.random() * 0.5 + 0.1,
      color: `hsl(${Math.random() * 360}, 100%, 75%)`
    };

    if (!isTooClose(newStar, stars)) {
      stars.push(newStar);
    }
  }

  useFrame(() => {
    if (starsRef.current) {
      starsRef.current.rotation.y += 0.00005;
    }
  });

  return (
    <group ref={starsRef}>
      {stars.map((star, i) => (
        <mesh key={i} position={star.position}>
          <sphereGeometry args={[star.size, 16, 16]} />
          <meshStandardMaterial 
            color={star.color} 
            emissive={star.color} 
            emissiveIntensity={0.8} 
          />
        </mesh>
      ))}
    </group>
  );
}

export default Stars;